<template>
  <div class="mod-article-inner">
    <preview-job-content-header title="勤務地エリア" />
    <p
      ref="places"
      class="location-area mb5"
      :class="{ 'omitted' : showTogglePlacesButton && !isOpenPlaces }"
      data-test="places"
      v-html="placeText"
    />
    <div
      v-if="showTogglePlacesButton"
      class="pega-location-area-accordion-link"
    >
      <a
        href="javascript:void(0);"
        data-test="toggle-button"
        @click="togglePlaces()"
      >
        <p class="pt5">{{ togglePlacesText }}</p>
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'

export default {
  components: {
    PreviewJobContentHeader
  },
  mixins: [jobPreviewVisibilityCommon],
  props: {
    places: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      placeTextHeight: 0,
      isOpenPlaces: true
    }
  },
  computed: {
    showTogglePlacesButton () {
      return this.placeTextHeight > 42
    }
  },
  mounted () {
    this.setToggleData()
  },
  methods: {
    setToggleData () {
      // 開閉処理用の情報取得
      this.$set(this, 'placeTextHeight', this.$refs.places.clientHeight)
      this.$set(this, 'isOpenPlaces', false)
    },
    togglePlaces () {
      this.$set(this, 'isOpenPlaces', !this.isOpenPlaces)
      this.$emit('toggle')
    }
  }
}
</script>
